import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import IngredientCard from '../components/IngredientCard';

import { getIngredients } from '../services/fetchIngredient';

function ExploreFoodsIngredients() {
  const [ingredients, setIngredients] = useState([]);

  useEffect(() => {
    async function fetchIngredients() {
      try {
        const ingredientsList = await getIngredients('meals');
        setIngredients(ingredientsList);
      } catch (error) {
        global.alert('Não foram encontrados ingredientes');
      }
    }
    fetchIngredients();
  }, []);

  return (
    <div className="ingredients-page">
      <Header Title="Ingredients" />
      <div className="ingredients-section">
        {ingredients.map((ingredient, index) => (
          <IngredientCard
            key={ index }
            index={ index }
            ingredient={ ingredient }
            type="foods"
          />
        ))}
      </div>
      <Footer />
    </div>

  );
}

export default ExploreFoodsIngredients;
